import { createContext, useContext } from 'react';

import { useRadioGroupState } from './useRadioGroupState';

export type RadioGroupState = ReturnType<typeof useRadioGroupState>;
export const RadioGroupContext = createContext<RadioGroupState | null>(null);
export const useRadioGroupContext = () => useContext(RadioGroupContext);
